import {store} from '../store'
import routes from '@/router/routeDefinition'
import {thirdPartModuleConfig} from '../../config/moduleConfig'
export default (to, from, next) => {
  if (to.path === '/') {
    let roles = store.getters.user.roles || []
    let firstRoute = Object.values(routes).find(route => {
      let routeAuth = (route.meta && route.meta.auth) || []
      return (routeAuth.length === 0 || roles.some(role => routeAuth.includes(role))) 
    })
    const env = process.env.NODE_ENV
    // next(firstRoute.path)
    const targetPath = thirdPartModuleConfig[env] ? '/profile' : firstRoute.path
    next(targetPath)
  }
  next()
}



// WEBPACK FOOTER //
// ./src/router/default-route.js